export default __webpack_public_path__ + "static/media/institute-23-min.d14b2efe.webp";